import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';
import _, { set } from 'lodash';

const initialState = generateReduxKeys({
    products: [],
    pagination: { page: 1, total: 0, totalPages: 0 },
    singleProduct: null,
    openOrderItems: [],
    offerProducts: [],
    recentProducts: [],
});

const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        setProducts: (state, action) => {
            state.products = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        appendProducts: (state, action) => {
            const newProducts = Array.isArray(action.payload) ? action.payload : [];
            const updatedProducts = [...state.products, ...newProducts];
            state.products = updatedProducts;
        },
        setSingleProduct: (state, action) => {
            state.singleProduct = action.payload;
        },
        appendOpenOrderItems: (state, action) => {
            if (!action.payload || (Array.isArray(action.payload) && action.payload.length === 0)) {
                state.openOrderItems = [];
                return;
            }

            const newOrders = Array.isArray(action.payload) ? action.payload : [action.payload];
            const currentOrderId = state.openOrderItems?.[0]?.order_id;
            const newOrderId = newOrders?.[0]?.order_id;

            let merged = [];
            if (currentOrderId && newOrderId && currentOrderId !== newOrderId) {
                merged = [];
            } else {
                merged = _.cloneDeep(state.openOrderItems || []);
            }

            newOrders.forEach((newOrder) => {
                const existing = _.find(merged, { product_netsuite_id: newOrder.product_netsuite_id });
                if (existing) {
                    existing.quantity = Number(newOrder.quantity) || 1;
                } else {
                    merged.push(newOrder);
                }
            });

            state.openOrderItems = merged;
        },
        removeOpenOrderItemById: (state, action) => {
            const updatedOrders = state.openOrderItems.filter((order) => order.id !== action.payload);
            state.openOrderItems = updatedOrders;
        },
        updateOpenOrderQuantityById: (state, action) => {
            const { id, quantity } = action.payload;

            const order = state.openOrderItems.find((o) => o.id === id);
            if (order) {
                order.quantity = Number(quantity) || 0;
            }
        },
        setOfferProducts: (state, action) => {
            state.offerProducts = action.payload;
        },
        setRecentProducts: (state, action) => {
            state.recentProducts = action.payload;
        },
    },
});

export const {
    setProducts,
    setPagination,
    appendProducts,
    setSingleProduct,
    appendOpenOrderItems,
    removeOpenOrderItemById,
    updateOpenOrderQuantityById,
    setRecentProducts,
} = productsSlice.actions;
export default productsSlice.reducer;
